<h2 class="font-theme-source mb-1 md:mb-2 block text-4xl md:text-4xl lg:text-4xl xl:text-5xl 2xl:text-5xl font-bold text-theme-black">{{text}}</h2>
